<template>
  <div class="home">

  <h2>Billing and payment</h2>

  <p class="text-secondary">
      Account reference: {{this.accountNumber }}.
  </p>

  <h4 class="mt-5">Payment methods</h4>

  <div v-if="this.paymentMethods === null || this.paymentMethods.length === 0">
    <p>No payment methods registered yet.</p>
  </div>

  <div v-if="this.paymentMethods != null && this.paymentMethods.length > 0">
    <table class="table">
      <tr>
        <th><!-- icon --></th>
        <th>Payment method</th>
        <th>Name on card</th>
        <th>Expires</th>
        <th><!-- is default ? --></th>
      </tr>

      <tbody>
        <tr v-for="(cc, idx) in creditcards" :key="idx">
            <td><component v-bind:is="cc.creditCardType"></component></td>
            <td><span class="ccType">{{ cc.creditCardType }}</span> ending {{ cc.creditCardNumber.slice(-8) }}</td>
            <td>{{ cc.nameOnAccount }}</td>
            <td>
              {{ cc.creditCardExpMonth }} / 20{{ cc.creditCardExpYear }}
              <b-badge variant="danger" v-if="isExpired(cc.creditCardExpMonth, cc.creditCardExpYear)">expired</b-badge>
            </td>
            <td><b-badge variant="info" v-if="cc.defaultAccount ==='Y'">default</b-badge></td>
        </tr>
      </tbody>
    </table>
  </div>

    <b-row>
      <b-col cols="12" class="text-right">
        <button
          class="btn btn-primary"
          @click.prevent="addPaymentMethod"
        >
          <b-icon icon="plus"></b-icon>
          Add a payment method
        </button>
      </b-col>
    </b-row>

  <br>
  <br>
  <br>

  <div v-if="invoices.length > 0">
    <h4 class="mt-5">Invoices</h4>

      <table class="table">
        <tr>
          <th>Invoice date</th>
          <th>Amount</th>
          <th>Due</th>
          <th>Status</th>
          <th>Invoice</th>
        </tr>
        <tr v-for="(inv, idx) in invoices" :key=idx>
            <td>{{ inv.generationTimestamp }}</td>
            <td>{{ inv.currencySymbol }} {{ inv.invAllocateAmt }}</td>
            <td>Due {{ inv.dueDate }}</td>
            <td>{{ inv.generationStatus }}</td>
            <td> <b-button v-b-tooltip.hover title="email or download" variant="info" size="sm" class="p-1">
                  <b-icon icon="file-arrow-down"></b-icon>
                </b-button>
            </td>
        </tr>
      </table>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import amex from '@/components/icons/amex.vue'
import diners from '@/components/icons/diners.vue'
import discover from '@/components/icons/discover.vue'
import generic from '@/components/icons/generic.vue'
import jcb from '@/components/icons/jcb.vue'
import maestro from '@/components/icons/maestro.vue'
import mastercard from '@/components/icons/mastercard.vue'
import visa from '@/components/icons/visa.vue'

export default {
  data () {
    return {

    }
  },
  components: {
    amex,
    diners,
    discover,
    generic,
    JCB: jcb,
    maestro,
    master_card: mastercard,
    visa

  },
  computed: {
    creditcards () {
      return this.paymentMethods
    },
    ...mapGetters([
      'paymentMethods',
      'invoices',
      'accountNumber'
    ])
  },
  methods: {
    // returns true if the creditcard expiry (mm / yy) is in the past
    isExpired (mm, yy) {
      const now = new Date()
      const year = now.getFullYear() - 2000
      const month = now.getMonth() + 1
      return yy < year || (yy === year && mm < month)
    },
    addPaymentMethod () {
      this.$router.push('/add_payment_method')
    }
  }
}
</script>

<style scoped>

.ccType {
  text-transform: capitalize;
  font-weight: bold;
}
</style>
